import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { AuthServerProvider } from '../services/auth/auth-jwt.service';
import { LoginService } from '../services/login/login.service';
import { SplashScreenService } from '../services/splash-screen/splash-screen.service';

export async function isAuthenticated(authServerProvider: AuthServerProvider): Promise<boolean> {
  return await authServerProvider.isAuthenticated();
}

export const authGuard: CanActivateFn = async () => {
  const authServerProvider = inject(AuthServerProvider);
  const loginService = inject(LoginService);
  const splashScreenService = inject(SplashScreenService);
  const router = inject(Router);

  try {
    const authenticated = await isAuthenticated(authServerProvider);

    await splashScreenService.hide();
    return authenticated;
  } catch (e) {
    console.error('Auth error', JSON.stringify(e));
    if (e instanceof HttpErrorResponse && e.status === HttpStatusCode.Forbidden) {
      await loginService.logout();
    }
  }
  return router.createUrlTree(['']);
};
